import React from "react";
import { Stack, Typography } from "@mui/material";

export default function Footer() {
  return (
    <Stack
      sx={{
        background: "black",
        alignItems: "center",
        justifyContent: "center",
        p: "1rem",
      }}
      direction={{xs: 'column', md: 'row'}}
    >
      <Typography sx={{ color: "#999999" }} variant="body2">
        Copyrights © 2025 All Rights Reserved by MYSAVCARE
      </Typography>
    </Stack>
  );
}
